import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faEdit,faTrash,faEye,faPlus } from '@fortawesome/free-solid-svg-icons'

library.add(faEdit,faTrash,faEye,faPlus)
Vue.component('fa-icon', FontAwesomeIcon)
